<template>
  <section class="popular_product_outer" :class="{ product_slider_wrap: is_slider}">
    <div class="container">
      <div class="popular_product_box">
        <h2><slot name="title"></slot></h2>
        <vue-slick-carousel v-if="is_slider" class="product_card_wrap flx product_slider" v-bind="settings">
          <trend-product-card
            v-for="item in items"
            :key="'popular-'+item.id"
            :product="item"
            :show_price="show_price"
          ></trend-product-card>
          <template #prevArrow="arrowOption">
            <button type="button" class="btn-juliet prev" :data-current="arrowOption.currentSlide"><i class="fa fa-left" aria-hidden="true"> </i></button>
          </template>
          <template #nextArrow="arrowOption">
            <button type="button" class="btn-juliet next" :data-current="arrowOption.currentSlide"><i class="fa fa-right" aria-hidden="true"> </i></button>
          </template>
        </vue-slick-carousel>
        <div v-else class="product_card_wrap flx">
          <trend-product-card v-for="item in items" :key="'popular-'+item.id" :product="item"></trend-product-card>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import TrendProductCard from '../../Product/TrendProductCard'
export default {
  name: 'PopularProducts',
  props: {
    show_price: {
      type: Boolean,
      default: false
    },
    is_slider: {
      type: Boolean,
      default: true
    },
    items: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        autoplay: false,
        autoplaySpeed: 5000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 640,
            settings: {
              slidesToShow: 1
            }
          },
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  components: {
    TrendProductCard,
    VueSlickCarousel
  }
}
</script>

<style scoped>

</style>
